
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.984 16.457c-.33-.156-1.907-.936-2.202-1.057-.294-.122-.502-.156-.727.173-.226.33-.832 1.04-1.023 1.265-.19.226-.364.243-.693 0a8.892 8.892 0 01-2.583-1.594 9.099 9.099 0 01-1.733-2.236c-.191-.312 0-.486.138-.66.139-.172.312-.363.486-.554.126-.165.231-.345.312-.537a.659.659 0 000-.572c0-.156-.728-1.733-1.006-2.375-.277-.641-.52-.554-.71-.554h-.694c-.33.013-.642.156-.866.398a3.64 3.64 0 00-1.127 2.687 6.222 6.222 0 001.3 3.38 14.421 14.421 0 005.53 4.853c.762.33 1.351.52 1.82.676.656.199 1.351.24 2.027.122a3.345 3.345 0 002.184-1.526c.2-.482.266-1.009.19-1.525-.086-.122-.294-.208-.623-.364z","fill":"#364A92"}}),_c('path',{attrs:{"d":"M22.226 4.653a12.757 12.757 0 00-9.17-3.779 12.896 12.896 0 00-11.11 19.327L.213 26.874l6.83-1.733a12.826 12.826 0 006.152 1.56h-.138a12.896 12.896 0 009.169-22.048zm-9.17 19.83c-1.922 0-3.81-.52-5.46-1.509l-.38-.225-4.056 1.057 1.074-3.952-.243-.398a10.712 10.712 0 0116.64-13.26 10.608 10.608 0 013.137 7.574 10.73 10.73 0 01-10.711 10.712z","fill":"#364A92"}})])
          )
        }
      }
    